<template>
  <div id="BoxInCart">
    <div :class="`cart-${cartKey}`">
      <h4 v-if="lang == 'en'">Your Box is in the cart...</h4>
      <h4 v-else>La tua Box è nel carrello...</h4>
      <a v-if="lang == 'en'" :href="cartUrl" class="btn btn-primary"
        >Go to cart</a
      >
      <a v-else :href="cartUrl" class="btn btn-primary">Vai al carrello</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cartKey: null,
    };
  },

  computed: {
    cartUrl: function() {
      return window["wcApiSettings"]._cart;
    },
  },

  props: {
    lang: String,
  },

  methods: {
    fetchCart: function() {
      const cart = localStorage.getItem("menaboh_cart");
      this.cartKey = cart;
    },
  },

  mounted() {
    this.fetchCart();
  },
};
</script>

<style scoped>
#BoxInCart {
  height: 200px;
  background: #eae4dc;
  text-align: center;
  justify-content: center;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
}
</style>
